// extracted by mini-css-extract-plugin
export var burger = "burger-module--burger--bb19e";
export var burger_open = "burger-module--burger_open--11d36 burger-module--burger--bb19e";